// Write your code here
import {Component} from 'react'
import './index.css'

class CoinToss extends Component {
  state = {isHead: true, total: 0, heads: 0, tails: 0}

  onClickToss = () => {
    const getNum = Math.floor(Math.random() * 2)
    if (getNum === 0) {
      this.setState(prevState => ({
        isHead: true,
        total: prevState.total + 1,
        heads: prevState.heads + 1,
      }))
    } else {
      this.setState(prevState => ({
        isHead: false,
        total: prevState.total + 1,
        tails: prevState.tails + 1,
      }))
    }
  }

  render() {
    const {isHead, total, heads, tails} = this.state

    return (
      <div className="main-Container">
        <div className="toss-container">
          <h1 className="heading">Coin Toss Game</h1>
          <p className="game-head">Heads (or) Tails</p>
          {isHead ? (
            <img
              className="coin-image"
              src="https://assets.ccbp.in/frontend/react-js/heads-img.png"
              alt="toss result"
            />
          ) : (
            <img
              className="coin-image"
              src="https://assets.ccbp.in/frontend/react-js/tails-img.png"
              alt="toss result"
            />
          )}

          <button className="coinBtn" type="button" onClick={this.onClickToss}>
            Toss Coin
          </button>
          <div className="result-Container">
            <p className="para">Total:{total}</p>
            <p className="para">heads:{heads}</p>
            <p className="para">Tails:{tails}</p>
          </div>
        </div>
      </div>
    )
  }
}

export default CoinToss
